/* eslint no-undef: 'off' */
import $ from 'jquery';

const ajax_faq_customizer2 = () => {
    $(document).on("click",'.js_faq_custom_2_get_result', () => {
        const attributes    = get_attributes();
        const ajax          = themeObj.ajax_handle_faq_customize2;
        const urlParams     = new URLSearchParams(window.location.search);
        const id            = urlParams.get('id') ? urlParams.get('id') : '';

        const data = {
            nonce: ajax.nonce,
            action: ajax.action,
            attributes: attributes,
            id: id,
        }

        $("body").addClass("mi-loading");

        $.ajax({
            type: 'POST',
            url: themeObj.ajaxUrl,
            data: data
        }).done((res) => {
            $("body").removeClass("mi-loading");
            const html  = res.data.render_result;
            $('.FaqQuestion__Fields.Result_Faq').html(html);
            $('.js-FaqQuestion__Fields__Wrapper').slick({
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                dots: false,
                variableWidth: true,
            });
        })
    })
}

const get_attributes = () => {
    const taxonomy = $('#taxonomy_custom_value').val();
    
    let attributes = {
        data: [],
        taxonomy : taxonomy
    }

    $('.FaqQuestion.js-FaqQuestion.FaqCustomize2Question').each(function () {
        const selectedRadio = $(this).find("input[type=radio]:checked");
        if (selectedRadio.length > 0) {
            const selectedValue = selectedRadio.val();
            const productid = selectedRadio.data('productid');
            const question = $(this).find(".heading-h-3-medium").text();
            let data_push = {
                question : question,
                answer : selectedValue,
                productid : productid,
            };

            attributes.data.push(data_push);
        }
    });
    return attributes;
}

const init = () => {
    ajax_faq_customizer2();
}

try {
    init();
} catch (error) {
    console.error(`This file error ${error}`);
}